import http from '@/communication/AuthConnection'

export default ({ distributorName }) => {
  return http.get('/v1/distributor', { params: { distributorName } })
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/distributor/search-distributor-by-name/index.js